export const Experiences = [
  {
    id: 'fol',
    title: 'General Chair Assistant',
    organization: 'Festival of Learning 2026',
    url: 'https://festival-of-learning-2026.info/',
    note: 'Jointly hosted by AIED, EDM, and L@S',
    location: 'Seoul, Korea',
    period: '2026.06.27 - 2026.07.03',
  },
  {
    id: 'lalalab',
    title: 'Research Intern',
    organization: 'LaLaLab',
    url: 'https://tomonag.org/lab/',
    advisor: ['tomo', 'mirella'],
    location: 'Remote',
    period: '2025.07 - 2025.08',
  },
  {
    id: 'kixlab',
    title: 'Research Intern',
    organization: 'KIXLAB',
    url: 'https://kixlab.com',
    advisor: ['juho'],
    location: 'Daejeon, Korea',
    period: '2024.07 - 2025.06',
  },
];